import { Injectable } from '@angular/core';
import { HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import {
  RtiHttpService,
  IMap
} from '../../../lib/angular/service/rti-HttpService';
import { Response } from '../../../lib/angular/model/common/response';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Injectable()
export class ddHttpService {
  /**
   * get()
   */
  protected _get<T>(
    endpoint: string,
    map?: IMap<T>,
    params?: object,
    headers?: HttpHeaders
  ): Observable<Response<T>> {
    //
    // Make RestApi Call
    //
    return this.http.get<T>(endpoint, map, params, headers);
  }

  /**
   * Put()
   */
  protected _put<T>(
    endpoint: string,
    model: any,
    id: any,
    map?: IMap<T>
  ): Observable<Response<T>> {
    //
    // Make RestApi Call
    //
    return this.http.put<T>(endpoint, model, map, { id });
  }

  /**
   * post()
   */
  protected _post<T>(
    endpoint: string,
    model: any,
    cb?: IMap<T>
  ): Observable<Response<T>> {
    //
    // Make RestApi Call
    //
    return this.http.post<T>(endpoint, model, cb);
  }

  /**
   * patch()
   */
  protected _patch<T>(
    endpoint: string,
    model: any,
    cb?: IMap<T>
  ): Observable<Response<T>> {
    //
    // Make RestApi Call
    //
    return this.http.patch<T>(endpoint, model, cb);
  }

  /**
   * delete()
   */
  protected _delete<T>(
    endpoint: string,
    params?: object,
    map?: IMap<T>
  ): Observable<Response<T>> {
    //
    // Make RestApi Call
    //
    return this.http.delete<T>(endpoint, params, map);
  }

  /**
   * constructor()
   */
  constructor(private http: RtiHttpService,
              private environment: EnvironmentConfiguration) {
    //
    // Use Node Environment Variables here....
    //
    http.server = environment.RTI_ENDPOINT.replace('https://', '');
    // http.server = http.server.replace('.dev.', '.test.');
    http.port = null; // env.apiPort;
    http.prefix = ''; // env.apiPrefix;
    http.secure = true; // env.security;
  }
}
